const Footer = {
  setToggleMenu: function () {
    const menus = document.querySelectorAll("[data-menu-footer]");

    if(menus.length > 0) menus.forEach(menu => {
      let menuItem = menu.querySelector(".menu-item");

      if(menuItem) menuItem.addEventListener("click", () => {
        menu.classList.toggle("-show");
      });
    });
  },
  init: function () {
    const _this = this;

    _this.setToggleMenu();
  },
};

export default Footer;
